import { useParams } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";

const CONTENT = {
  "risk-disclosure": {
    title: "Risk Disclosure",
    body: [
      "Trading financial instruments involves significant risk and may not be suitable for all investors. You could lose some or all of your invested capital; therefore you should not invest money that you cannot afford to lose.",
      "The information, signals and analytics provided by KREONIS are for informational and educational purposes only. They are probabilistic analytical estimates and are not guarantees of future performance.",
      "Past performance does not guarantee future results. Always consider your own risk tolerance, objectives and financial circumstances, and seek independent advice where appropriate.",
    ],
  },
  "terms": {
    title: "Terms of Service",
    body: [
      "By accessing or using KREONIS you agree to these Terms. KREONIS is a market-intelligence, analysis and education platform. It does not provide brokerage services, custody funds, or execute real-money trades.",
      "You are solely responsible for your own trading and investment decisions. Nothing on the platform constitutes personalised regulated investment advice.",
      "This is placeholder legal content for a demo build and must be reviewed by a qualified legal professional before any commercial launch.",
    ],
  },
  "privacy": {
    title: "Privacy Policy",
    body: [
      "We collect the minimum information necessary to operate the service — such as your email, profile preferences and usage analytics — to provide and improve KREONIS.",
      "Passwords are stored only as bcrypt hashes. We never store payment card details; payments are processed by our payment provider.",
      "This is placeholder content for a demo build and should be reviewed by a qualified professional before commercial launch.",
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    body: [
      "We use essential cookies to keep you signed in (secure httpOnly session cookies) and to remember preferences such as your theme.",
      "We may use privacy-respecting analytics cookies to understand aggregate usage. You can control cookies through your browser settings.",
    ],
  },
  "ai-disclaimer": {
    title: "AI Disclaimer",
    body: [
      "KREONIS uses language models to explain structured market data. The AI does not invent prices, indicators, news or signals — it interprets data supplied by the application.",
      "AI outputs are probabilistic and may contain errors. They are not financial advice and must not be relied upon as guarantees. Always verify information and apply your own judgement and risk management.",
    ],
  },
  "responsible-trading": {
    title: "Responsible Trading",
    body: [
      "We believe in disciplined, risk-first trading. Never risk more than you can afford to lose, use stop losses, size positions responsibly and avoid over-exposure.",
      "KREONIS positions itself as market intelligence, AI analysis, education, paper trading, backtesting and risk management. We do not offer portfolio management, fund custody, brokerage or automatic real-money execution.",
      "If trading is negatively affecting your wellbeing or finances, please step back and seek support.",
    ],
  },
};

export default function Legal({ page }) {
  const params = useParams();
  const key = page || params.page;
  const c = CONTENT[key] || CONTENT["terms"];
  return (
    <MarketingLayout>
      <Seo title={c.title} />
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{c.title}</h1>
        <div className="mt-6 space-y-4">
          {c.body.map((p, i) => <p key={i} className="text-base leading-relaxed text-muted-foreground">{p}</p>)}
        </div>
        <p className="mt-8 rounded-xl border border-warning/30 bg-warning/5 p-4 text-xs text-muted-foreground">
          This legal content is placeholder for a demo build and is editable by administrators. It must be professionally reviewed before commercial launch.
        </p>
      </div>
    </MarketingLayout>
  );
}
